import { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

function PasswordInput({ value, onChange, placeholder, required = true }) {
  const [visible, setVisible] = useState(false);

  return (
    <InputGroup>
      <Form.Control
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
      />
      <Button
        variant="outline-secondary"
        onClick={() => setVisible(v => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
      </Button>
    </InputGroup>
  );
}

export { PasswordInput };
